import React, { useEffect, useState } from "react";

function ResumeDetails(props) {
    
    const attb = ["title", "name", "location", "date", "skill", "language", "knowledge", "details"]
    
    const [attributes, setAttributes] = useState([])

    const [filtered, setFiltered] = useState(false)

    const filter = () => {
        let aux = []
        console.log(props.object);
        for(let i = 0; i < attb.length; i++){
            if(props.object.length !== 0){
                if(props.object[0].hasOwnProperty(attb[i])){
                    aux.push(attb[i])
                }
            }
        }
        console.log(aux);
        setAttributes(aux)
        setFiltered(true)
    }

    if(!filtered){
        filter()
    }

    useEffect(() => {

    }, [attributes])
    

    return(
        <div className="resumeDetail">
            {props.object.slice(0).reverse().map((ob) => {
                console.log(ob);
                console.log(attributes);
                return(
                    <div className="resumeDetail__element">
                        <p className="resumeDetail__title">{ob[attributes[0]]}</p>
                        <p className="resumeDetail__location">{ob[attributes[1]]}</p>
                        <p className="resumeDetail__date"><i>{ob[attributes[2]]}</i></p>
                        <p className="resumeDetail__details">{ob[attributes[3]]}</p>
                    </div>
                )
            })}
        </div>
    )
}

export default ResumeDetails